import styled from 'styled-components'
import EditIcon from '@material-ui/icons/Create'
import { colors } from '../../../../../../theme/Global'

export const StyledEditIcon = styled(EditIcon)`
  cursor: pointer;
  display: block;
  margin-top: 9px;
  color: ${colors.darkGrey};
`

export const StyledParagraph = styled.p`
  margin: 0px;
`

export const labelStyle = {
  textAlign: 'left',
  fontWeight: '500',
  fontSize: '14px'
}

export const warningNoteStyle = {
  textAlign: 'left',
  fontStyle: 'italic',
  fontSize: '12px'
}

export const warningNoteContainerStyle = { marginTop: '1rem' }
